import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "./Center";
import style from "./CardList.module.css";
import { ReactComponent as GridIcon } from "resources/img/icons/grid.svg";
import { ReactComponent as ListIcon } from "resources/img/icons/list.svg";
import ProductCard from "components/card/product/ProductCard";
import { useRef, useState } from "react";
import clsx from "classnames";
import { storeRequester } from "App";
import { toast } from "react-toastify";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { useContext } from "react";
import { useEffect } from "react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { AuthContext } from "providers/AuthProvider";
import CategoryPanel from "routes/front/main/productList/CategoryPanel";
import { useTranslation } from "react-i18next";
import PaddingWrapper from "./PaddingWrapper";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { useDispatch } from "react-redux";

function CardList(props) {
    const ref = useRef();
    const { t } = useTranslation();
    const [dummies, setDummies] = useState([]);
    // const [currentType, setCurrentType] = useState(GALLERY);
    const GALLERY = 0;
    const LIST = 1;
    const { currentType, setCurrentType } = props;
    const dispatch = useDispatch();
    const [interests, setInterests] = useState([]);

    const { isMobile } = useContext(BrowserDetectContext);
    const { userName } = useContext(AuthContext);

    // 관심 상품 목록을 한 번만 조회
    const fetchInterests = () => {
        if (!userName) return;
        storeRequester.getInterest(
            (response) => setInterests(response.interests)
        );
    };


    // 관심 상품 토글 핸들러
    const handleWishToggle = async (productId, isWished) => {
        try {
            if (isWished) {
                // 관심 상품에서 제거
                const interestToDelete = interests.find(
                    interest => interest.product_id === productId
                );
                if (interestToDelete) {
                    await storeRequester.delete(`/customers/me/interests/${interestToDelete.id}`);
                    // toast.success('관심상품에 추가되었습니다', {
                    //     autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    // });
                }
            } else {
                // 관심 상품에 추가
                const req = { product_id: productId };
                await storeRequester.postInterest(req)

            }
            // 관심 상품 목록 갱신
            fetchInterests();
        } catch (error) {
            toast.error('처리 중 오류가 발생했습니다', {
                autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
            });
        }
    };


    const initDummies = () => {
        if (props.data) {
            let cols = 4;
            let lastRowCols = props.data.length % cols;
            let needs = cols - lastRowCols;
            let dummies = Array.from({ length: needs });
            setDummies(dummies);
        }
    }


    const onTypeChangeClick = (type) => {
        dispatch(HistoryReducer.actions.setCurrentType(type));
    }


    useEffect(() => {
        initDummies();
    }, [props.data]);

    useEffect(() => {
        if (userName) {
            fetchInterests();
        }
        else {
            setInterests([])
        }
    }, [userName]);


    useEffect(() => {
        if (props.data) {
            initDummies();
        }
    }, [props.data]);

    const Skeleton = () => {
        return (
            <>
                <div className={style.card}>
                    {
                        currentType === LIST ?
                            <ProductCard template={props.template} type={"horizontal"} skeleton />
                            : <ProductCard template={props.template} skeleton />
                    }
                </div>
                <div className={style.card}>
                    {
                        currentType === LIST ?
                            <ProductCard template={props.template} type={"horizontal"} skeleton />
                            : <ProductCard template={props.template} skeleton />
                    }
                </div>
                <div className={style.card}>
                    {
                        currentType === LIST ?
                            <ProductCard template={props.template} type={"horizontal"} skeleton />
                            : <ProductCard template={props.template} skeleton />
                    }
                </div>
                <div className={style.card}>
                    {
                        currentType === LIST ?
                            <ProductCard template={props.template} type={"horizontal"} skeleton />
                            : <ProductCard template={props.template} skeleton />
                    }
                </div>
            </>
        )
    }

    return (
        <div className={style.wrap} ref={ref} style={{ width: isMobile && currentType !== LIST && "100%" }}>
            <VerticalFlex gap={40}>
                <FlexChild>
                    <PaddingWrapper>
                        <HorizontalFlex>
                            <FlexChild width={"fit-content"}>
                                <HorizontalFlex gap={10}>
                                    <FlexChild width={"fit-content"}>
                                        <P size={24} weight={700}>{props.title}</P>
                                    </FlexChild>
                                    <FlexChild width={25}>
                                        <img className={style.icon} src={props.headerIcon} alt={""} />
                                    </FlexChild>
                                </HorizontalFlex>
                            </FlexChild>
                            <FlexChild width={"fit-content"}>
                                <HorizontalFlex gap={5}>
                                    {
                                        props.viewType &&
                                        <>
                                            <FlexChild width={20}>
                                                <Center>
                                                    <GridIcon className={clsx(style.displayTypeIcon, { [style.active]: currentType === GALLERY })} onClick={() => onTypeChangeClick(GALLERY)} />
                                                </Center>
                                            </FlexChild>
                                            <FlexChild width={20}>
                                                <Center>
                                                    <ListIcon className={clsx(style.displayTypeIcon, { [style.active]: currentType === LIST })} onClick={() => onTypeChangeClick(LIST)} />
                                                </Center>
                                            </FlexChild>
                                        </>
                                    }
                                </HorizontalFlex>
                            </FlexChild>
                        </HorizontalFlex>
                    </PaddingWrapper>
                </FlexChild>
                <FlexChild>
                    <div className={clsx(style.listWrap, { [style.list]: currentType === LIST }, { [style.mobile]: isMobile })}>
                        {
                            props.data && props.data.length > 0 ? props.data.map((product, index) =>
                                <div className={clsx(style.card, { [style.mobile]: isMobile }, { [style.horizontalListCard]: currentType === LIST })} key={index} >
                                    {
                                        currentType === LIST ?
                                            <ProductCard
                                                data={product}
                                                template={props.template}
                                                type="horizontal"
                                                interests={interests}
                                                onWishToggle={handleWishToggle}
                                            />
                                            : <ProductCard
                                                data={product}
                                                template={props.template}
                                                interests={interests}
                                                onWishToggle={handleWishToggle}
                                            />
                                    }
                                </div>
                            )
                                :
                                <Center>
                                    <P>상품이 없습니다</P>
                                </Center>
                            // <Skeleton />

                        }
                        {
                            dummies && dummies.map((dummy, index) =>
                                <div className={style.card} key={index} style={{ flex: isMobile ? `1 1 37%` : `1 1 18%` }}>

                                </div>
                            )
                        }
                    </div>
                </FlexChild>
            </VerticalFlex>
        </div>
    );
}

export default CardList;